import { reduxKey } from './constants';
import { CommentReaction } from './types';
export const getCommentState = (commentId)=>(state)=>commentId && state[reduxKey][commentId] || {};
export const isInitialized = (commentId)=>(state)=>commentId && state[reduxKey] !== undefined && state[reduxKey][commentId] !== undefined;
export const isFeatured = (commentId)=>(state)=>getCommentState(commentId)(state)['isFeatured'];
export const isLiked = (commentId)=>(state)=>getCommentState(commentId)(state)['isLiked'];
export const isHidden = (commentId)=>(state)=>getCommentState(commentId)(state)['isHidden'];
export const isSpam = (commentId)=>(state)=>getCommentState(commentId)(state)['isSpam'];
export const getLikes = (commentId)=>(state)=>getCommentState(commentId)(state)['likes'];
export const isCommentReduxReady = (state)=>!!state[reduxKey];
export function getCommentsByUser(state, userId) {
    const comments = state[reduxKey];
    const commentsByUser = [];
    for(const commentId in comments){
        var _comment_user;
        const comment = state[commentId];
        if ((comment === null || comment === void 0 ? void 0 : (_comment_user = comment.user) === null || _comment_user === void 0 ? void 0 : _comment_user.userId) === userId) {
            commentsByUser.push(comment);
        }
    }
    return commentsByUser;
}
export const getCommentReactions = (state, comment)=>{
    var _state_reduxKey;
    const stateSlice = (_state_reduxKey = state[reduxKey]) !== null && _state_reduxKey !== void 0 ? _state_reduxKey : {};
    var _stateSlice_reactions;
    const reactions = (_stateSlice_reactions = stateSlice['reactions']) !== null && _stateSlice_reactions !== void 0 ? _stateSlice_reactions : {};
    if (!reactions[comment.commentId] && comment.likes > 0) {
        return {
            [CommentReaction.Like]: true
        };
    }
    var _reactions_comment_commentId;
    return (_reactions_comment_commentId = reactions[comment.commentId]) !== null && _reactions_comment_commentId !== void 0 ? _reactions_comment_commentId : {};
};
